import React from 'react';
import { Clock3 } from 'lucide-react';
import Button from 'components/buttons/Button';
import DaveImage from 'assets/profile-photos/Dave.webp';

export default function AssessmentIntroduction({
  onStart,
  weightLoss = false,
}: {
  onStart: () => void;
  weightLoss?: boolean;
}) {
  return (
    <div className="assessment-introduction relative mx-auto w-full max-w-3xl rounded-3xl bg-white p-6 shadow-sm md:p-10">
      {!weightLoss && (
        <div className="assessment-duration absolute right-4 top-4 inline-flex items-center gap-1 rounded-full border border-[#E6ECEB] bg-[#FAFCFC] px-2 py-1 text-[11px] font-semibold text-brand-mid-gray md:hidden">
          <Clock3 className="h-3.5 w-3.5" aria-hidden="true" />
          <span className="text-md">less than 2 mins</span>
        </div>
      )}
      <div className="assessment-intro-content flex flex-col items-center text-center">
        <div className="assessment-portrait h-16 w-16 overflow-hidden rounded-full border border-[#E6ECEB] bg-white">
          <img src={DaveImage} alt="David Massie" className="assessment-dave h-full w-full object-cover" />
        </div>
        <p className="talo-clinician-name mt-1 text-base font-bold text-brand-black sm:text-lg">
          David Massie MPharm (IP) MBA
        </p>
        <p className="talo-clinician-role text-sm text-brand-mid-gray">Superintendent Pharmacist · GPhC #2058682</p>
        <h1 className="assessment-title mt-3 md:mt-6 font-mont text-lg font-black leading-tight text-brand-black sm:text-xl lg:text-2xl">
          Let&apos;s find the right {weightLoss ? 'weight loss' : 'erectile dysfunction'} treatment for&nbsp;you
        </h1>

        <div className="assessment-consent-panel mt-3 md:mt-8 w-full rounded-2xl border border-[#E6ECEB] bg-[#FAFCFC] p-3 text-left md:p-6">
          <p className="text-md font-bold text-brand-black sm:text-lg">Do you agree and consent to the following?</p>
          <ul className="mt-2 md:mt-4 space-y-2 md:space-y-3 text-[15px] md:text-md text-brand-mid-gray">
            <li className="flex gap-3">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-talo-dark-green" />
              <span>
                {weightLoss
                  ? 'I am over 18 years old and live in the UK.'
                  : 'I am male, over 18 years old and live in the UK.'}
              </span>
            </li>
            <li className="flex gap-3">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-talo-dark-green" />
              <span>I will be the sole user of any medication offered to me through this service.</span>
            </li>
            <li className="flex gap-3">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-talo-dark-green" />
              <span>I confirm all answers are provided by me, and will be truthful.</span>
            </li>
          </ul>
        </div>

        <div className="assessment-start mt-6 w-full">
          <Button
            text="I agree"
            link="#"
            variant="primary"
            iconAfter="arrow-right"
            className="w-full"
            onClick={(e) => {
              e.preventDefault();
              onStart();
            }}
          />
        </div>

        <div className="assessment-trust mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[14px] text-brand-mid-gray">
          <span>⚡ Fast delivery</span>
          <span>🔒 Private &amp; secure</span>
          <span>✓ No commitment</span>
        </div>
      </div>
    </div>
  );
}
